import {CanActivateFn, Params, Router, UrlTree} from '@angular/router';
import {FeatureToggleService} from '@ccp/services/toggle-features/feature-toggle.service';
import {inject} from '@angular/core';
import {UrlManager} from '@ccp/lib/url-manager';
import {UrlParamLiterals} from '@ccp/enums/literals/urlparams.enum';
import {UserAgent} from '@ccp/lib/user-agent';
import {Views} from '@ccp/config/views';
import {HydraSso, HydraSsoStates} from '../lib/hydra-sso';
import {ToggleFeatures} from '@ccp/enums/toggleFeatures.enum';
import {Logger} from '../lib/logger';
import {LocaleContextService} from '@ccp/services/app-context/locale-context.service';
import {UserContextService} from '@ccp/services/app-context/user-context.service';

const FALLBACK_ROUTE = Views.portfolio.path;

let router: Router;

export const LoginGuard: CanActivateFn = async (route) => {
  router = inject(Router);

  const localeContextService = inject(LocaleContextService);
  const userContextService = inject(UserContextService);
  const featureToggleService = inject(FeatureToggleService);

  let params: Params = route.queryParams;
  let returnUrl = params[UrlParamLiterals.ReturnUrl];

  if (userContextService.currentUser$()?.isLogged) {
    if (UserAgent.checkUserAgentIsWeChat()) {
      return redirectToWeChatUrlCallBack(params, returnUrl);
    }
    if (returnUrl) {
      returnUrl = decodeURIComponent(returnUrl);
      const extractedParams = UrlManager.getParams(returnUrl);
      returnUrl = returnUrl.split('?')[0];
      params = {...params, ...extractedParams};
    }

    return router.createUrlTree([returnUrl ? returnUrl : FALLBACK_ROUTE], {queryParams: params});
  }

  const callbackUrl =
    localeContextService.currentCountry$().targetDomain +
    UrlManager.absolutePath(localeContextService.currentLang$().isoCode) +
    UrlManager.absolutePath(buildReturnUrlFromHashParam(returnUrl, params[UrlParamLiterals.Hash]));

  HydraSso.Authorize(
    localeContextService.currentCountry$(),
    localeContextService.currentLang$(),
    callbackUrl,
    !!featureToggleService.featureConfig$()?.getConfig(ToggleFeatures.hydraSso),
    userContextService.currentUser$(),
  )
    .then((e) => {
      Logger.debug('hydra hautorize :', {messageContext: e});
      return e === HydraSsoStates.deactivated || e === HydraSsoStates.challengeKeyRetrieved;
    })
    .catch((e) => {
      Logger.error('Hydra SSO error at authorize', {error: e});
      return router.createUrlTree([callbackUrl], {queryParams: params});
    });
};

function redirectToWeChatUrlCallBack(params: Params, returnUrl: string | null): UrlTree {
  if (returnUrl) {
    return router.createUrlTree([returnUrl], {queryParams: params});
  } else {
    return router.createUrlTree([FALLBACK_ROUTE], {queryParams: params});
  }
}

function buildReturnUrlFromHashParam(returnUrl: string | null, hash: string | null): string {
  if (returnUrl && hash) {
    returnUrl = returnUrl + '&hash=' + hash;
  } else if (!returnUrl) {
    returnUrl = FALLBACK_ROUTE;
  }
  return returnUrl;
}
